/* Template literal utilities. */

/*
 * Utility to write template literals without having to worry about whitespace
 * after newline feeds and before text, and newline feeds.
 */
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.noMultiSpaceAfterLineFeed = noMultiSpaceAfterLineFeed;
exports.noMultiLine = noMultiLine;
exports.noWhitespace = noWhitespace;

function noMultiSpaceAfterLineFeed(literals) {
  for (var _len = arguments.length, values = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    values[_key - 1] = arguments[_key];
  }

  return literals.reduce(function (result, literal, index) {
    result += literal

    // Remove multiple blank spaces after a carriage return.
    .replace(/\n +/g, "\n")

    // Remove initial and final newline feeds. .trim() does this, but it
    // does too much for us.
    .replace(/^\n/, "").replace(/\n$/, "");

    if (index < values.length) {
      result += values[index];
    }

    return result;
  }, "");
}

/*
 * Utility to remove all newline characters from a template literal.
 */

function noMultiLine(literals) {
  for (var _len2 = arguments.length, values = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
    values[_key2 - 1] = arguments[_key2];
  }

  return literals.reduce(function (result, literal, index) {
    result += literal.replace(/\r?\n|\r/g, "");

    if (index < values.length) {
      result += values[index];
    }

    return result;
  }, "");
}

/*
 * Utility to remove all whitespace in template literals.
 */

function noWhitespace(literals) {
  for (var _len3 = arguments.length, values = Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
    values[_key3 - 1] = arguments[_key3];
  }

  return literals.reduce(function (result, literal, index) {
    result += literal.replace(/\s+/g, "");

    if (index < values.length) {
      result += values[index];
    }

    return result;
  }, "");
}


//////////////////
// WEBPACK FOOTER
// /private/var/folders/n9/yczdnstj3wdc9q5tzm6d45c00000gp/T/maison-encans-auex-website/~/tempura/lib/index.js
// module id = 31
// module chunks = 6